import { render, staticRenderFns } from "./ShopStoreTakeoutOrder.vue?vue&type=template&id=25ff9f4f&scoped=true"
import script from "./ShopStoreTakeoutOrder.vue?vue&type=script&lang=js"
export * from "./ShopStoreTakeoutOrder.vue?vue&type=script&lang=js"
import style0 from "./ShopStoreTakeoutOrder.vue?vue&type=style&index=0&id=25ff9f4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ff9f4f",
  null
  
)

export default component.exports